export const ROUTES = {
  TRACK_PAGE_VISITS: '/tracking/page-visits',
};

export const REDUCER_PATH = 'trackingApi';
